import { FontAwesome, QesIcons } from "./qesIcons";
import { IconStorage } from "./interfaces";

// font awesome imports
import { angleDoubleRight, angleDoubleUp } from "./icon-data/font-awesome/angleDouble";
import { archive } from "./icon-data/font-awesome/archive";
import { arrowDown, arrowLeft, arrowRight, arrowUp, arrows, arrowsHorizontal, arrowsVertical } from "./icon-data/font-awesome/arrow";
import { ban } from "./icon-data/font-awesome/ban";
import { bank } from "./icon-data/font-awesome/bank";
import { barChart } from "./icon-data/font-awesome/barChart";
import { binoculars } from "./icon-data/font-awesome/binoculars";
import { book } from "./icon-data/font-awesome/book";
import { briefcase } from "./icon-data/font-awesome/briefcase";
import { building } from "./icon-data/font-awesome/building";
import { bullseye } from "./icon-data/font-awesome/bullseye";
import { calendar } from "./icon-data/font-awesome/calendar";
import { caretDown, caretRight, caretUp } from "./icon-data/font-awesome/caret";
import { chain } from "./icon-data/font-awesome/chain";
import { check, checkCircle, checkSquare, checkSquareOutline } from "./icon-data/font-awesome/check";
import { chevronDown, chevronRight } from "./icon-data/font-awesome/chevron";
import { circle, circleOutline, circleOutlineNotched, circleThin } from "./icon-data/font-awesome/circle";
import { clockOutline } from "./icon-data/font-awesome/clock";
import { clone } from "./icon-data/font-awesome/clone";
import { close } from "./icon-data/font-awesome/close";
import { cloudDownload } from "./icon-data/font-awesome/cloudDownload";
import { cog, cogs } from "./icon-data/font-awesome/cog";
import { copy } from "./icon-data/font-awesome/copy";
import { crosshairs } from "./icon-data/font-awesome/crosshairs";
import { database } from "./icon-data/font-awesome/database";
import { desktop } from "./icon-data/font-awesome/desktop";
import { dotCircleOutline } from "./icon-data/font-awesome/dotCircleOutline";
import { download, upload } from "./icon-data/font-awesome/download";
import { dragAndDropTexture } from "./icon-data/untitled-ui/dragAndDropTexture";
import { edit } from "./icon-data/font-awesome/edit";
import { ellipsisVertical } from "./icon-data/font-awesome/ellipsisVertical";
import { envelope } from "./icon-data/font-awesome/envelope";
import { eraser } from "./icon-data/font-awesome/eraser";
import { exchange } from "./icon-data/font-awesome/exchange";
import { exclamationCircle, exclamationTriangle } from "./icon-data/font-awesome/exclamation";
import { externalLink } from "./icon-data/font-awesome/externalLink";
import { eye } from "./icon-data/font-awesome/eye";
import { fax } from "./icon-data/font-awesome/fax";
import { filePdfOutline, filesOutline, fileZipOutline } from "./icon-data/font-awesome/file";
import { filter } from "./icon-data/font-awesome/filter";
import { floppyDiskOutline } from "./icon-data/font-awesome/floppyDiskOutline";
import { folder } from "./icon-data/font-awesome/folder";
import { globe } from "./icon-data/font-awesome/globe";
import { history } from "./icon-data/font-awesome/history";
import { home } from "./icon-data/font-awesome/home";
import { idBadge } from "./icon-data/font-awesome/idBadge";
import { infoCircle } from "./icon-data/font-awesome/infoCircle";
import { laptop } from "./icon-data/font-awesome/laptop";
import { lineChart } from "./icon-data/font-awesome/lineChart";
import { list } from "./icon-data/font-awesome/list";
import { locationArrow } from "./icon-data/font-awesome/locationArrow";
import { lock, unlock } from "./icon-data/font-awesome/lock";
import { longArrowDown, longArrowUp } from "./icon-data/font-awesome/longArrow";
import { LowVision } from "./icon-data/font-awesome/lowVision";
import { map, mapMarker, mapPin } from "./icon-data/font-awesome/map";
import { minus, minusCircle } from "./icon-data/font-awesome/minus";
import { objectGroup } from "./icon-data/font-awesome/objectGroup";
import { pencil, pencilSquareOutline } from "./icon-data/font-awesome/pencil";
import { phone } from "./icon-data/font-awesome/phone";
import { play } from "./icon-data/font-awesome/play";
import { plug } from "./icon-data/font-awesome/plug";
import { plus, plusCircle } from "./icon-data/font-awesome/plus";
import { question, questionCircle } from "./icon-data/font-awesome/question";
import { refresh } from "./icon-data/font-awesome/refresh";
import { rocket } from "./icon-data/font-awesome/rocket";
import { search } from "./icon-data/font-awesome/search";
import { sellsy } from "./icon-data/font-awesome/sellsy";
import { server } from "./icon-data/font-awesome/server";
import { share } from "./icon-data/font-awesome/share";
import { signIn } from "./icon-data/font-awesome/signIn";
import { signOut } from "./icon-data/font-awesome/signOut";
import { sliders } from "./icon-data/font-awesome/sliders";
import { sort } from "./icon-data/font-awesome/sort";
import { spinner } from "./icon-data/font-awesome/spinner";
import { squareOutline } from "./icon-data/font-awesome/squareOutline";
import { star } from "./icon-data/font-awesome/star";
import { stop, stopCircle, stopCircleOutline } from "./icon-data/font-awesome/stop";
import { tag, tags } from "./icon-data/font-awesome/tag";
import { tasks } from "./icon-data/font-awesome/tasks";
import { thLarge } from "./icon-data/font-awesome/thLarge";
import { thumbsOutlineUp } from "./icon-data/font-awesome/thumbsOutlineUp";
import { times, timesCircle, timesCircleOutline, timesLight } from "./icon-data/font-awesome/times";
import { toggleOff, toggleOn } from "./icon-data/font-awesome/toggle";
import { trash, trashOutline } from "./icon-data/font-awesome/trash";
import { umbrella } from "./icon-data/font-awesome/umbrella";
import { university } from "./icon-data/font-awesome/university";
import { user, userMd, userPlus, userTimes, users } from "./icon-data/font-awesome/user";
import { wrench } from "./icon-data/font-awesome/wrench";

// untitled imports
import { circle as circleUntitled } from "./icon-data/untitled-ui/circle";
import { hexagonV1, hexagonV2 } from "./icon-data/untitled-ui/hexagon";
import { layers2v1, layers2v2, layers3v1, layers3v2 } from "./icon-data/untitled-ui/layers";
import { pentagon } from "./icon-data/untitled-ui/pentagon";
import { square } from "./icon-data/untitled-ui/square";
import { menuV1 } from "./icon-data/untitled-ui/menu";
import { databaseV1 } from "./icon-data/untitled-ui/database";
import { bookmarkAdd } from "./icon-data/untitled-ui/bookmark";
import { briefcaseV1 } from "./icon-data/untitled-ui/briefcase";
import { downloadCloudV1, downloadV1 } from "./icon-data/untitled-ui/download";
import { lifeBuoyV1 } from "./icon-data/untitled-ui/lifeBuoy";
import { presentationChartV1 } from "./icon-data/untitled-ui/presentationChart";
import { toolV2 } from "./icon-data/untitled-ui/tool";
import { folder as folderUntitled } from "./icon-data/untitled-ui/folder";
import { dotsVertical } from "./icon-data/untitled-ui/dots";
import { pencilV1 } from "./icon-data/untitled-ui/pencil";
import { shareV4, shareV6 } from "./icon-data/untitled-ui/share";
import { trashV1 } from "./icon-data/untitled-ui/trash";
import { uploadV1 } from "./icon-data/untitled-ui/upload";
import { plus as plusUntitled, plusCircle as plusCircleUntitled } from "./icon-data/untitled-ui/plus";
import { archive as archiveUntitled } from "./icon-data/untitled-ui/archive";
import { x, xCircle, xClose } from "./icon-data/untitled-ui/x";
import { alignLeftV1, alignRightV1 } from "./icon-data/untitled-ui/align";
import { gridV1 } from "./icon-data/untitled-ui/grid";
import { expandV1 } from "./icon-data/untitled-ui/expand";
import { eyeOff, eye as eyeUntitled } from "./icon-data/untitled-ui/eye";
import { phone as phoneUntitled } from "./icon-data/untitled-ui/phone";
import { printer } from "./icon-data/untitled-ui/printer";
import { refreshCcwV2 } from "./icon-data/untitled-ui/refresh";
import { searchSm } from "./icon-data/untitled-ui/search";
import { settingsV2 } from "./icon-data/untitled-ui/settings";
import { switchHorizontalV1, switchVerticalV1 } from "./icon-data/untitled-ui/switch";
import { zap } from "./icon-data/untitled-ui/zap";
import { list as listUntitled } from "./icon-data/untitled-ui/list";
import { buildingV7 } from "./icon-data/untitled-ui/building";
import { copyV7 } from "./icon-data/untitled-ui/copy";
import { rocketV2 } from "./icon-data/untitled-ui/rocket";
import { route } from "./icon-data/untitled-ui/route";
import { userPlusV1, userV1, userXV1 } from "./icon-data/untitled-ui/user";
import { usersV1 } from "./icon-data/untitled-ui/users";
import { filterLines } from "./icon-data/untitled-ui/filter";
import { slidersV4 } from "./icon-data/untitled-ui/sliders";
import { alertHexagon, alertTriangle, alertTriangleColored } from "./icon-data/untitled-ui/alert";
import { arrowNarrowDown, arrowNarrowLeft, arrowNarrowRight, arrowNarrowUp, arrowsHorizontal as arrowsHorizontalUntitled, arrowsVertical as arrowsVerticalUntitled } from "./icon-data/untitled-ui/arrow";
import { chevronDown as chevronDownUntitled, chevronRight as chevronRightUntitled, chevronLeft, chevronUp, chevronRightDouble, chevronUpDouble } from "./icon-data/untitled-ui/chevron";
import { flagV1 } from "./icon-data/untitled-ui/flag";
import { glassesV2 } from "./icon-data/untitled-ui/glasses";
import { loadingV1 } from "./icon-data/untitled-ui/loading";
import { terminalBrowser } from "./icon-data/untitled-ui/terminal";
import { infoCircle as infoCircleUntitled } from "./icon-data/untitled-ui/info";
import { check as checkUntitled, checkCircle as checkCircleUntitled, checkVerifiedV2 } from "./icon-data/untitled-ui/check";
import { slashOctagon } from "./icon-data/untitled-ui/slash";
import { targetV4 } from "./icon-data/untitled-ui/target";
import { scissorsV2 } from "./icon-data/untitled-ui/scissors";
import { clockRewind } from "./icon-data/untitled-ui/clock";
import { helpCustom } from "./icon-data/untitled-ui/help";
import { homeV3 } from "./icon-data/untitled-ui/home";
import { linkV4 } from "./icon-data/untitled-ui/link";
import { mailV1 } from "./icon-data/untitled-ui/mail";
import { mapV1 } from "./icon-data/untitled-ui/map";
import { markerPinV1, markerPinV6 } from "./icon-data/untitled-ui/markerPin";
import { play as playUntitled } from "./icon-data/untitled-ui/play";
import { logInV1 } from "./icon-data/untitled-ui/logIn";
import { logOutV1 } from "./icon-data/untitled-ui/logOut";
import { starV1 } from "./icon-data/untitled-ui/star";
import { tagV1 } from "./icon-data/untitled-ui/tag";
import { barChartV7 } from "./icon-data/untitled-ui/barChart";
import { fileV4 } from "./icon-data/untitled-ui/file";
import { lockUnlockCustom, lockV1 } from "./icon-data/untitled-ui/lock";
import { tooth } from "./icon-data/untitled-ui/tooth";
import { calendar as calendarUntitled } from "./icon-data/untitled-ui/calendar";
import { minusSquare } from "./icon-data/untitled-ui/minusSquare";
import { plusSquare } from "./icon-data/untitled-ui/plusSquare";
import { providerMapPin } from "@app/shared/icons/icon-data/untitled-ui/providerMapPin";
import { minus as minusUntitled } from "@app/shared/icons/icon-data/untitled-ui/minus";
import { minusCircle as minusCircleUntitled } from "./icon-data/untitled-ui/minusCircle";
import { thumbsDown } from "@app/shared/icons/icon-data/untitled-ui/thumbsDown";
import { thumbsUp } from "@app/shared/icons/icon-data/untitled-ui/thumbsUp";
import { countyMap } from "@app/shared/icons/icon-data/other/countyMap";
import { quinn } from "@app/shared/icons/icon-data/other/quinn";

const iconLookupFontAwesome = new Map<string, IconStorage>([
  [FontAwesome.AngleDoubleRight, angleDoubleRight],
  [FontAwesome.AngleDoubleUp, angleDoubleUp],
  [FontAwesome.Archive, archive],
  [FontAwesome.ArrowDown, arrowDown],
  [FontAwesome.ArrowLeft, arrowLeft],
  [FontAwesome.ArrowRight, arrowRight],
  [FontAwesome.ArrowUp, arrowUp],
  [FontAwesome.Arrows, arrows],
  [FontAwesome.ArrowsHorizontal, arrowsHorizontal],
  [FontAwesome.ArrowsVertical, arrowsVertical],
  [FontAwesome.Ban, ban],
  [FontAwesome.Bank, bank],
  [FontAwesome.BarChart, barChart],
  [FontAwesome.Binoculars, binoculars],
  [FontAwesome.Book, book],
  [FontAwesome.Briefcase, briefcase],
  [FontAwesome.Building, building],
  [FontAwesome.Bullseye, bullseye],
  [FontAwesome.Calendar, calendar],
  [FontAwesome.CaretDown, caretDown],
  [FontAwesome.CaretRight, caretRight],
  [FontAwesome.CaretUp, caretUp],
  [FontAwesome.Chain, chain],
  [FontAwesome.Check, check],
  [FontAwesome.CheckCircle, checkCircle],
  [FontAwesome.CheckSquare, checkSquare],
  [FontAwesome.CheckSquareOutline, checkSquareOutline],
  [FontAwesome.ChevronDown, chevronDown],
  [FontAwesome.ChevronRight, chevronRight],
  [FontAwesome.Circle, circle],
  [FontAwesome.CircleOutline, circleOutline],
  [FontAwesome.CircleOutlineNotched, circleOutlineNotched],
  [FontAwesome.CircleThin, circleThin],
  [FontAwesome.ClockOutline, clockOutline],
  [FontAwesome.Clone, clone],
  [FontAwesome.Close, close],
  [FontAwesome.CloudDownload, cloudDownload],
  [FontAwesome.Cog, cog],
  [FontAwesome.Cogs, cogs],
  [FontAwesome.Copy, copy],
  [FontAwesome.Crosshairs, crosshairs],
  [FontAwesome.Database, database],
  [FontAwesome.Desktop, desktop],
  [FontAwesome.DotCircleOutline, dotCircleOutline],
  [FontAwesome.Download, download],
  [FontAwesome.Edit, edit],
  [FontAwesome.EllipsisVertical, ellipsisVertical],
  [FontAwesome.Envelope, envelope],
  [FontAwesome.Eraser, eraser],
  [FontAwesome.Exchange, exchange],
  [FontAwesome.ExclamationCircle, exclamationCircle],
  [FontAwesome.ExclamationTriangle, exclamationTriangle],
  [FontAwesome.ExternalLink, externalLink],
  [FontAwesome.Eye, eye],
  [FontAwesome.Fax, fax],
  [FontAwesome.FilePdfOutline, filePdfOutline],
  [FontAwesome.FileZipOutline, fileZipOutline],
  [FontAwesome.FilesOutline, filesOutline],
  [FontAwesome.Filter, filter],
  [FontAwesome.FloppyDiskOutline, floppyDiskOutline],
  [FontAwesome.Folder, folder],
  [FontAwesome.Globe, globe],
  [FontAwesome.History, history],
  [FontAwesome.Home, home],
  [FontAwesome.IdBadge, idBadge],
  [FontAwesome.InfoCircle, infoCircle],
  [FontAwesome.Laptop, laptop],
  [FontAwesome.LineChart, lineChart],
  [FontAwesome.List, list],
  [FontAwesome.LocationArrow, locationArrow],
  [FontAwesome.Lock, lock],
  [FontAwesome.LongArrowDown, longArrowDown],
  [FontAwesome.LongArrowUp, longArrowUp],
  [FontAwesome.LowVision, LowVision],
  [FontAwesome.Map, map],
  [FontAwesome.MapMarker, mapMarker],
  [FontAwesome.MapPin, mapPin],
  [FontAwesome.Minus, minus],
  [FontAwesome.MinusCircle, minusCircle],
  [FontAwesome.ObjectGroup, objectGroup],
  [FontAwesome.Pencil, pencil],
  [FontAwesome.PencilSquareOutline, pencilSquareOutline],
  [FontAwesome.Phone, phone],
  [FontAwesome.Play, play],
  [FontAwesome.Plug, plug],
  [FontAwesome.Plus, plus],
  [FontAwesome.PlusCircle, plusCircle],
  [FontAwesome.Question, question],
  [FontAwesome.QuestionCircle, questionCircle],
  [FontAwesome.Refresh, refresh],
  [FontAwesome.Rocket, rocket],
  [FontAwesome.Search, search],
  [FontAwesome.Sellsy, sellsy],
  [FontAwesome.Server, server],
  [FontAwesome.Share, share],
  [FontAwesome.SignIn, signIn],
  [FontAwesome.SignOut, signOut],
  [FontAwesome.Sliders, sliders],
  [FontAwesome.Sort, sort],
  [FontAwesome.Spinner, spinner],
  [FontAwesome.SquareOutline, squareOutline],
  [FontAwesome.Star, star],
  [FontAwesome.Stop, stop],
  [FontAwesome.StopCircle, stopCircle],
  [FontAwesome.StopCircleOutline, stopCircleOutline],
  [FontAwesome.Tag, tag],
  [FontAwesome.Tags, tags],
  [FontAwesome.Tasks, tasks],
  [FontAwesome.ThLarge, thLarge],
  [FontAwesome.ThumbsOutlineUp, thumbsOutlineUp],
  [FontAwesome.Times, times],
  [FontAwesome.TimesCircle, timesCircle],
  [FontAwesome.TimesCircleOutline, timesCircleOutline],
  [FontAwesome.TimesLight, timesLight],
  [FontAwesome.ToggleOff, toggleOff],
  [FontAwesome.ToggleOn, toggleOn],
  [FontAwesome.Trash, trash],
  [FontAwesome.TrashOutline, trashOutline],
  [FontAwesome.Umbrella, umbrella],
  [FontAwesome.University, university],
  [FontAwesome.Unlock, unlock],
  [FontAwesome.Upload, upload],
  [FontAwesome.User, user],
  [FontAwesome.UserMd, userMd],
  [FontAwesome.UserPlus, userPlus],
  [FontAwesome.Users, users],
  [FontAwesome.UserTimes, userTimes],
  [FontAwesome.Wrench, wrench],
]);

const iconLookupUntitled = new Map<string, IconStorage>([
  [QesIcons.AlertHexagon, alertHexagon],
  [QesIcons.AlertTriangle, alertTriangle],
  [QesIcons.AlertTriangleColored, alertTriangleColored],
  [QesIcons.AlignLeftV1, alignLeftV1],
  [QesIcons.AlignRightV1, alignRightV1],
  [QesIcons.Archive, archiveUntitled],
  [QesIcons.ArrowNarrowDown, arrowNarrowDown],
  [QesIcons.ArrowNarrowLeft, arrowNarrowLeft],
  [QesIcons.ArrowNarrowRight, arrowNarrowRight],
  [QesIcons.ArrowNarrowUp, arrowNarrowUp],
  [QesIcons.ArrowsHorizontal, arrowsHorizontalUntitled],
  [QesIcons.ArrowsVertical, arrowsVerticalUntitled],
  [QesIcons.BarChartV7, barChartV7],
  [QesIcons.BookmarkAdd, bookmarkAdd],
  [QesIcons.Briefcase, briefcaseV1],
  [QesIcons.BuildingV7, buildingV7],
  [QesIcons.Calendar, calendarUntitled],
  [QesIcons.Check, checkUntitled],
  [QesIcons.CheckCircle, checkCircleUntitled],
  [QesIcons.CheckVerifiedV2, checkVerifiedV2],
  [QesIcons.ChevronDown, chevronDownUntitled],
  [QesIcons.ChevronLeft, chevronLeft],
  [QesIcons.ChevronRight, chevronRightUntitled],
  [QesIcons.ChevronRightDouble, chevronRightDouble],
  [QesIcons.ChevronUp, chevronUp],
  [QesIcons.ChevronUpDouble, chevronUpDouble],
  [QesIcons.Circle, circleUntitled],
  [QesIcons.ClockRewind, clockRewind],
  [QesIcons.CopyV7, copyV7],
  [QesIcons.CountyMap, countyMap],
  [QesIcons.Database, databaseV1],
  [QesIcons.DotsVertical, dotsVertical],
  [QesIcons.Download, downloadV1],
  [QesIcons.DownloadCloudV1, downloadCloudV1],
  [QesIcons.DragAndDropTexture, dragAndDropTexture],
  [QesIcons.ExpandV1, expandV1],
  [QesIcons.Eye, eyeUntitled],
  [QesIcons.EyeOff, eyeOff],
  [QesIcons.FileV4, fileV4],
  [QesIcons.FilterLines, filterLines],
  [QesIcons.FlagV1, flagV1],
  [QesIcons.Folder, folderUntitled],
  [QesIcons.GlassesV2, glassesV2],
  [QesIcons.GridV1, gridV1],
  [QesIcons.Help, helpCustom],
  [QesIcons.HexagonOnEdge, hexagonV2],
  [QesIcons.HexagonOnVertex, hexagonV1],
  [QesIcons.HomeV3, homeV3],
  [QesIcons.InfoCircle, infoCircleUntitled],
  [QesIcons.LayersThreeV1, layers3v1],
  [QesIcons.LayersThreeV2, layers3v2],
  [QesIcons.LayersTwoV1, layers2v1],
  [QesIcons.LayersTwoV2, layers2v2],
  [QesIcons.LifeBuoyV1, lifeBuoyV1],
  [QesIcons.LinkV4, linkV4],
  [QesIcons.List, listUntitled],
  [QesIcons.LoadingV1, loadingV1],
  [QesIcons.LockV1, lockV1],
  [QesIcons.LogInV1, logInV1],
  [QesIcons.LogOutV1, logOutV1],
  [QesIcons.MailV1, mailV1],
  [QesIcons.MapV1, mapV1],
  [QesIcons.MarkerPinV1, markerPinV1],
  [QesIcons.MarkerPinV6, markerPinV6],
  [QesIcons.MenuV1, menuV1],
  [QesIcons.Minus, minusUntitled],
  [QesIcons.MinusCircle, minusCircleUntitled],
  [QesIcons.MinusSquare, minusSquare],
  [QesIcons.PencilV1, pencilV1],
  [QesIcons.Pentagon, pentagon],
  [QesIcons.PhoneV1, phoneUntitled],
  [QesIcons.Play, playUntitled],
  [QesIcons.Plus, plusUntitled],
  [QesIcons.PlusCircle, plusCircleUntitled],
  [QesIcons.PlusSquare, plusSquare],
  [QesIcons.PresentationChartV1, presentationChartV1],
  [QesIcons.Printer, printer],
  [QesIcons.ProviderMapPin, providerMapPin],
  [QesIcons.Quinn, quinn],
  [QesIcons.RefreshCcwV2, refreshCcwV2],
  [QesIcons.RocketV2, rocketV2],
  [QesIcons.Route, route],
  [QesIcons.ScissorsV2, scissorsV2],
  [QesIcons.SearchSm, searchSm],
  [QesIcons.SettingsV2, settingsV2],
  [QesIcons.ShareV4, shareV4],
  [QesIcons.ShareV6, shareV6],
  [QesIcons.SlashOctagon, slashOctagon],
  [QesIcons.SlidersV4, slidersV4],
  [QesIcons.Square, square],
  [QesIcons.StarV1, starV1],
  [QesIcons.SwitchHorizontalV1, switchHorizontalV1],
  [QesIcons.SwitchVerticalV1, switchVerticalV1],
  [QesIcons.TagV1, tagV1],
  [QesIcons.TargetV4, targetV4],
  [QesIcons.TerminalBrowser, terminalBrowser],
  [QesIcons.ThumbsDown, thumbsDown],
  [QesIcons.ThumbsUp, thumbsUp],
  [QesIcons.ToolV2, toolV2],
  [QesIcons.Tooth, tooth],
  [QesIcons.TrashV1, trashV1],
  [QesIcons.Unlock, lockUnlockCustom],
  [QesIcons.UploadV1, uploadV1],
  [QesIcons.UserPlusV1, userPlusV1],
  [QesIcons.UsersV1, usersV1],
  [QesIcons.UserV1, userV1],
  [QesIcons.UserXV1, userXV1],
  [QesIcons.X, x],
  [QesIcons.XCircle, xCircle],
  [QesIcons.XClose, xClose],
  [QesIcons.Zap, zap],
]);

export const iconLookup = new Map<string, IconStorage>([
  ...iconLookupFontAwesome,
  ...iconLookupUntitled,
]);